import React from "react";
import { useTranslation } from "react-i18next";
import BannerSectionStyle3 from "../Section/BannerSection/BannerSectionStyle3";
import BannerSectionStyle4 from "../Section/BannerSection/BannerSectionStyle4";
import Section from "../Section";
import DepartmentSectionStyle2 from "../Section/DepartmentSection/DepartmentSectionStyle2";
import FunFactSection from "../Section/FunFactSection";
import { pageTitle } from "../../helpers/PageTitle";
import SEO from '../SEO';

export default function About() {
  const { t } = useTranslation();
  pageTitle(t("about.pageTitle"));

  const servicesData = [ //test
    {
      title: t("about.service1Title"),
      subTitle: t("about.service1Desc"),
      iconUrl: "/images/icons/calendar_white.svg",
      href: "/services",
    },
    {
      title: t("about.service2Title"),
      subTitle: t("about.service2Desc"),
      iconUrl: "/images/icons/calendar_white.svg",
      href: "/services",
    },
    {
      title: t("about.service3Title"),
      subTitle: t("about.service3Desc"),
      iconUrl: "/images/icons/calendar_white.svg",
      href: "/services",
    },
    {
      title: t("about.service4Title"),
      subTitle: t("about.service4Desc"),
      iconUrl: "/images/icons/calendar_white.svg",
      href: "/services",
    },
    {
      title: t("about.service5Title"),
      subTitle: t("about.service5Desc"),
      iconUrl: "/images/icons/calendar_white.svg",
      href: "/services",
    },
  ];

  const coreValuesData = [
    {
      title: t("about.value1Title"),
      subTitle: t("about.value1Desc"),
      iconUrl: "images/icons/professional.svg",
    },
    {
      title: t("about.value2Title"),
      subTitle: t("about.value2Desc"),
      iconUrl: "images/icons/comprehensive.svg",
    },
    {
      title: t("about.value3Title"),
      subTitle: t("about.value3Desc"),
      iconUrl: "images/icons/patient.svg",
    },
    {
      title: t("about.value4Title"),
      subTitle: t("about.value4Desc"),
      iconUrl: "images/icons/facilities.svg",
    },
  ];

  const statsData = [
    { number: t("about.stat1Number"), title: t("about.stat1Title") },
    { number: t("about.stat2Number"), title: t("about.stat2Title") },
    { number: t("about.stat3Number"), title: t("about.stat3Title") },
    { number: t("about.stat4Number"), title: t("about.stat4Title") },
    { number: t("about.stat5Number"), title: t("about.stat5Title") },
  ];

  return (
    <>
      <SEO title="Rreth Nesh" description="Mësoni më shumë rreth Incomed, misionit tonë dhe ekipit tonë të dedikuar për shëndetësinë në Shqipëri." url="/about" />
      <BannerSectionStyle3
        bgUrl="/images/about/banner_bg.svg"
        imgUrl="/images/banner/incomed_entry.jpg"
        title={t("about.bannerTitle")}
        subTitle={t("about.bannerSubtitle")}
      />

      <Section topMd={200} topLg={150} topXl={110}>
        <DepartmentSectionStyle2
          sectionTitle={t("about.servicesTitle")}
          sectionTitleUp={t("about.servicesTitleUp")}
          data={servicesData}
        />
      </Section>

      <Section>
        <FunFactSection
          bgUrl="/images/about/fun_fact_bg.jpeg"
          data={statsData}
        />
      </Section>

      <Section topMd={175} topLg={125} topXl={85} bottomMd={100} bottomLg={110}>
        <div className="cs_shape_wrap">
          <div className="cs_shape_1 cs_position_1" />
          <div className="container">
            <div className="row flex-xl-row flex-column-reverse">
              <div className="col-xl-5">
                <div className="cs_pr_95 text-center cs_img_filed">
                  <img
                    src="/images/banner/banner_4.jpg"
                    alt="Core Values"
                    className="cs_radius_30"
                  />
                </div>
              </div>
              <div className="col-xl-7">
                <h2 className="cs_fs_72 mb-0">{t("about.whyChooseTitle")}</h2>
                <div className="cs_height_42 cs_height_xl_25" />

                {/* Core Values */}
                <div className="row">
                  {coreValuesData.map((item, index) => (
                    <div className="col-md-6" key={index}>
                      <div className="cs_iconbox cs_style_6">
                        <div className="cs_iconbox_icon cs_center cs_accent_bg rounded-circle">
                          <img src={item.iconUrl} alt="Icon" />
                        </div>
                        <h2 className="cs_iconbox_title cs_fs_32 cs_semibold">
                          {item.title}
                        </h2>
                        <p className="cs_iconbox_subtitle m-0">
                          {item.subTitle}
                        </p>
                      </div>
                      <div className="cs_height_85 cs_height_lg_60 cs_height_xl_35" />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Section>

      <Section className="cs_footer_margin_0">
        <BannerSectionStyle4
          bgUrl="/images/banner/banner_3.jpg"
          title={t("about.ctaTitle")}
          subTitle={t("about.ctaSubtitle")}
          center
        />
      </Section>
    </>
  );
}
